// removed by extract-text-webpack-plugin
module.exports = {"container":"container-33CH_","header":"header-2l5RR","headerText":"headerText-3uz9B","viewAll":"viewAll-1ANu5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/routes/_recentRoutes.css
// module id = 1218
// module chunks = 1